import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Row,
  Container,
  Table,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import magic1 from "../Images/bixkeyword.png";
import magic2 from "../Images/keyw2.png";
import Magickeyword from "./Keywordmagictol";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import pay from "../Images/pay.png";
import TestimonialPage from "./Testonomialraghar";
import SideTab from "./Toolstab";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import { basicauth } from "../Utils/Credentials";
import { Helmet } from "react-helmet";
const Magictool = () => {
  const jsonLdData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "Best Keyword Research Tool 2025 – Powered by SeoBix",
    url: "https://seobix.com/best-keyword-research-tool",
    description:
      "Discover the Best Keyword Research Tool 2025 with SeoBix. Uncover high-performing keywords, boost your SEO strategy, and drive more traffic to your website effortlessly.",
    applicationCategory: "SEO Tool",
    operatingSystem: "Web",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
      category: "Free SEO Tool",
    },
    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Best Keyword Research Tool",
          item: "https://seobix.com/best-keyword-research-tool",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "SeoBix",
      url: "https://seobix.com",
      logo: {
        "@type": "ImageObject",
        url: "https://seobix.com/Images/Backlinks.png",
        width: 600,
        height: 60,
      },
    },
    inLanguage: "en",
    keywords: [
      "Best keyword research tool 2025",
      "Keyword research software",
      "SeoBix keyword tool",
      "SEO keyword finder",
      "Keyword analysis tool",
    ],
  };

  return (
    <div>
      <Helmet>
        <title>Best Keyword Research Tool 2025 – Powered by SeoBix</title>
        <meta
          name="description"
          content="Discover the Best Keyword Research Tool 2025 with SeoBix. Uncover high-performing keywords, boost your SEO strategy, and drive more traffic to your website effortlessly."
        />
        <link
          rel="canonical"
          href="https://seobix.com/best-keyword-research-tool"
        />

        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://seobix.com/best-keyword-research-tool"
        />
        <meta
          property="og:title"
          content="Best Keyword Research Tool 2025 – Powered by SeoBix"
        />
        <meta
          property="og:description"
          content="Discover the Best Keyword Research Tool 2025 with SeoBix. Uncover high-performing keywords, boost your SEO strategy, and drive more traffic to your website effortlessly."
        />
        <meta
          property="og:image"
          content="https://seobix.com/Images/Backlinks.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://seobix.com/best-keyword-research-tool"
        />
        <meta
          name="twitter:title"
          content="Best Keyword Research Tool 2025 – Powered by SeoBix"
        />
        <meta
          name="twitter:description"
          content="Discover the Best Keyword Research Tool 2025 with SeoBix. Uncover high-performing keywords, boost your SEO strategy, and drive more traffic to your website effortlessly."
        />
        <meta
          name="twitter:image"
          content="https://seobix.com/Images/Backlinks.png"
        />

        <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      </Helmet>
      <Nav />
      <Container fluid className="p-0 mt-5" style={{ overflow: "clip" }}>
        <Magickeyword />
        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <Content />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <p className="mt-5">
        In the highly competitive digital landscape, choosing the right keywords
        can be the difference between success and stagnation. Our best keyword
        research tool helps marketers, bloggers and business owners uncover high
        performing keywords that drive targeted traffic, boost engagement and
        improve search engine rankings. Having practical insights at your
        fingertips, you can create a content that appeals to your audience as
        well as to the search engines.
      </p>

      <h3>Why You Need a Keyword Research Tool</h3>
      <p>
        The key to achieving any successful SEO strategy is to have an insight
        into how your audience searches. The keyword research tool that we offer
        gives you an in depth information on search trends, competition and
        search volume, allowing you to focus on the most impactful and relevant
        keywords. Knowing this, you will be able to unlock opportunities that
        have never been explored, find the right audience and make content
        strategy decisions that are datalaid. With actionable insights, your web
        site will always be ranked higher in search engines and will reach the
        most important users. This will make your SEO efficient and effective.
      </p>

      <div style={{ position: "relative" }}>
        <p
          style={{
            maxHeight: showMore ? "none" : "4.2rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 2,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            filter: showMore ? "none" : "blur(2px)",
            transition: "all 0.3s ease",
            marginBottom: showMore ? "1rem" : "2.5rem",
          }}
        >
          Investing in high priced SEO tools might not be a possibility to
          beginners or small businesses. This is why our free keyword research
          tool and free key word analysis tool are the most appropriate tools to
          begin with SEO. These tools will enable you to brainstorm on the
          keyword ideas, analyze search volume, evaluate competition and track
          trends easily. With no prior knowledge of SEO, you are able to develop
          content strategies, which provide quantifiable outcomes. With these
          free tools, you can optimize your site, target your audience and
          create a competitive advantage without having to spend a lot of money.
        </p>

        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>

      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <h3>The next level of Keyword Analysis is Professional</h3>
          <p>
            To SEO professionals and marketing agencies, our tool is commonly
            known as the best keyword analysis tool and key word analysis tool
            due to the high features. You can also assess the difficulty of
            keywords in order to find the most promising opportunities, find
            long tail keywords to target a niche and monitor competitor keywords
            in order to outcompete them. With such insights, you are able to
            create a more advanced content and SEO strategy. This guarantees a
            sustainable growth, increased rankings and increased ROI of your
            site or customer campaigns. The sophisticated analytics provide the
            professionals with the advantage that they require to remain
            relevant in a competitive society.
          </p>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={magic1}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>
          <h3>Our SEO Keyword Research Tool has the following features</h3>
          <p>
            Our search engine optimization tool with a keyword search is a tool
            that is simple to use and has robust functionalities to facilitate
            analyzing keywords easily. It provides correct search volume
            statistics, suggestions of keywords in real time and detailed
            performance and ROI reports. Be it the analysis of keywords to be
            used in a blog post or a content strategy or a large-scale marketing
            campaign, this tool assists you in making informed decisions. It
            enables the optimization of your SEO time by saving time and
            offering actionable insights. You can also be sure that with this
            tool you will be able to roll out strategies that will provide
            measurable results and long term success.
          </p>
          <h2 className="mt-2 mb-3">
            Bix keyword Research Giving You Extra Points:
          </h2>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={magic2}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>

          <h2>Frequently Asked Questions (FAQ)</h2>

          <Accordion defaultActiveKey="0" className="mb-5" flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                Which is the most useful keyword research tool?
              </Accordion.Header>
              <Accordion.Body>
                A platform that assists you to find the best performing
                keywords, competition analysis and search trends is the best
                keyword research tool. The tool is meant to be used by
                marketers, bloggers and businesses to increase the traffic of
                their websites and enhance better SEO ranking positions.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                What is a keyword research tool?
              </Accordion.Header>
              <Accordion.Body>
                A keyword research tool functions on the principle of analyzing
                data of search engines to come up with keywords that are being
                actively searched. It gives you data on the volume of search the
                difficulty of a keyword, trends and associated keywords enabling
                you to design user friendly content that draws the suitable
                crowd.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                Do you have any free keyword research tools?
              </Accordion.Header>
              <Accordion.Body>
                Yes! We provide options of free keyword research tools and free
                tools to analyse keywords so that beginners and small businesses
                can to explore the opportunity of keywords with no cost. These
                tools assist in the creation of ideas, the study of competition
                and planning of content strategies effectively.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                Why is your tool the best keyword analysis tool?
              </Accordion.Header>
              <Accordion.Body>
                Our site has been regarded as the most useful key word analysis
                tool due to its simplicity coupled with the sophisticated
                attributes. Competitor tracking, long-tail keywords
                recommendations and real time keyword data This keyword analysis
                tool is used by professionals to come up with data-driven SEO
                strategies.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                Is this an SEO tool that can be used to conduct competitor
                analysis?
              </Accordion.Header>
              <Accordion.Body>
                Absolutely, The use of our SEO keyword research tool enables you
                to examine competitor keywords, learn what they have or have not
                succeeded in and as well as new opportunities of your content.
                You would learn what makes others effective and with that you
                would be able to optimize your own web site and beat the
                competition.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
          <h3>Start Your SEO Journey Today With SeoBix</h3>
          <p>
            Just because you are looking into free tools of the keyword analysis
            or because you are trying to find the ultimate best keyword analysis
            tool, our platform can give you all that you need to be more
            visible, reach the right audience and be ahead of the competition.
            With the best keyword research tool, you are able to convert the
            knowledge about the keywords into practical plans that can provide
            tangible outcomes. It is time to start optimizing and open the
            potential of your site.
          </p>
          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <TestimonialPage />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>
            Try Our Service Free for 3 Months!
          </span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() => window.open("https://dashboard.seobix.com/", "_blank")}
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selfDomain, setSelfDomain] = useState("");
  const [competitorDomain, setCompetitorDomain] = useState("");
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const [expandedRow, setExpandedRow] = useState(null);
  const [apiData, setApiData] = useState([]);

  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);
  const handleSubmit = async () => {
    const uuid = generateUUID();
    const session = generateUUID();
    const urls = [selfDomain, competitorDomain].filter(Boolean);
    setLoading(true);
    const scope = selectedDomainType.value === "root" ? "domain" : "subdomain";
    const requestData = {
      uuid,
      urls,
      scope,
      session,
    };
    console.log("Request Data:", requestData);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchBulkSiteMetrics`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (data.status === "0") {
        setApiData(data.data);
        setLoading(false);
      } else {
        console.error("Error fetching data:", data.msg);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };

  const handleClick = () => {
    navigate("/keyword-gap");
  };

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Keyword Gaps vs Your Competitors</b>
            </h3>
            <p className="text-center">
              Discover which keywords your competitors rank for — but you don’t.
              Uncover missed SEO opportunities and boost your content strategy.
            </p>

            <Form className="mb-2">
              <Row className="align-items-center gx-2">
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter your domain"
                      value={selfDomain}
                      onChange={(e) => setSelfDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter competitor domain"
                      value={competitorDomain}
                      onChange={(e) => setCompetitorDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Row className="g-2 align-items-center">
                    <Col xs={9}>
                      <Form.Group className="mb-0">
                        <Form.Select
                          value={selectedDomainType}
                          onChange={(e) =>
                            setSelectedDomainType(e.target.value)
                          }
                          aria-label="Select Domain Type"
                          style={{
                            borderRadius: "6px",
                            padding: "0.5rem",
                            fontWeight: "500",
                            color: "#333",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                          }}
                        >
                          <option value="">Select Domain Type</option>
                          <option value="root">Root Domain</option>
                          <option value="sub">Sub Domain</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={3}>
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={handleSubmit}
                        style={{ whiteSpace: "nowrap", width: "100%" }}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
            <div className=" mt-4">
              {apiData.length > 0 && (
                <Table responsive>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                  </colgroup>

                  <thead>
                    <tr>
                      <th className="text-center">Domain</th>
                      <th className="px-3">Domain Authority</th>
                      <th className="px-3">Page Authority</th>
                      <th className="px-3">Spam Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData.map((item, index) => (
                      <React.Fragment key={item.id}>
                        <tr>
                          <td className="text-center">{item.url}</td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.da}
                              stroke="#799EFF"
                              label={`${item.da}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.pa}
                              stroke="#FFA500"
                              label={`${item.pa}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut value={item.spam_score} />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
            <h6 className="text-end m-4" onClick={handleClick}>
              Click to get more details <FaArrowRight />
            </h6>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const CustomDoughnut = ({ value, size = 64 }) => {
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((100 - value) / 100) * circumference;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "relative",
      }}
    >
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#799EFF"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progress}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#0A3981",
        }}
      >
        {value}%
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Keyword Gap Analyzer",
    description:
      "Discover keyword opportunities by comparing your website with top competitors. Uncover missing keywords and content gaps.",
    linkText: "Keyword Gap Tool",
    linkUrl: "/keyword-gap",
    bgColor: "#f4f7fb",
  },
  {
    title: "Ranking Keywords by Domain",
    description:
      "Find out which keywords each domain ranks for, and analyze traffic-driving terms for any site in your niche.",
    linkText: "Ranking Keyword Tool",
    linkUrl: "/bix-keyword-analyzer",
    bgColor: "#dff5ff",
  },
  {
    title: "Keyword Position Tracker",
    description:
      "Track daily keyword rankings for your target terms. Monitor SERP positions, gains, and drops across devices and locations.",
    linkText: "Position Tracker",
    linkUrl: "/keyword-position-tracker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Keyword Builder",
    description:
      "Generate powerful keyword combinations to boost your SEO strategy. Build long-tail and intent-based keyword lists in seconds.",
    linkText: "Keyword Builder",
    linkUrl: "/construct-your-seo-success-with-keyword-builder",
    bgColor: "#d6ffd6",
  },
];

const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            All-in-One Keyword Intelligence Suite: Discover, Track, and Optimize
            Every Opportunity
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Magictool;
